import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row dashboard__table-row" }
const _hoisted_2 = { class: "col-md-12 overflow-x" }
const _hoisted_3 = {
  key: 0,
  class: "c-table-checkbox"
}
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "4%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "1%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "25%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "1%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "3%" })
], -1)
const _hoisted_6 = {
  class: "dashboard__table-header",
  role: "rowgroup"
}
const _hoisted_7 = { role: "row" }
const _hoisted_8 = {
  class: "dashboard__table-th text-left",
  "aria-sort": "none"
}
const _hoisted_9 = { class: "dashboard__table-title" }
const _hoisted_10 = ["aria-sort"]
const _hoisted_11 = ["aria-sort"]
const _hoisted_12 = ["aria-sort"]
const _hoisted_13 = ["aria-sort"]
const _hoisted_14 = {
  class: "dashboard__table-th dashboard__table-th--p text-left",
  "aria-sort": "none"
}
const _hoisted_15 = { class: "dashboard__table-title" }
const _hoisted_16 = { class: "dashboard__table-body" }
const _hoisted_17 = {
  key: 1,
  class: "c-spin--"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_order_table_item = _resolveComponent("order-table-item")!
  const _component_p_spinner = _resolveComponent("p-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.allowedCheckbox)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onChange: _cache[0] || (_cache[0] = (e) => _ctx.pickAll(e))
                }, null, 32),
                _createElementVNode("i", {
                  style: _normalizeStyle(!_ctx.isPicked ? 'background: white' : '')
                }, null, 4)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", {
        class: "dashboard__table",
        role: "grid",
        style: _normalizeStyle(
                    _ctx.allowedCheckbox ? 'border-spacing: 0 4px;' : 'border-spacing: 0 8px;'
                )
      }, [
        _hoisted_5,
        _createElementVNode("thead", _hoisted_6, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("th", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.orderStatus" })
              ])
            ]),
            _createElementVNode("th", {
              class: _normalizeClass(["dashboard__table-th dashboard__table-sorting text-left", _ctx.sortingClass(_ctx.orderTableColumns.Date)]),
              "aria-sort": _ctx.sortAria
            }, [
              _createElementVNode("div", {
                class: "dashboard__table-title",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCurrentSortType(_ctx.orderTableColumns.Date))),
                style: {"white-space":"nowrap"}
              }, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.orderDate" })
              ])
            ], 10, _hoisted_10),
            _createElementVNode("th", {
              class: _normalizeClass(["dashboard__table-th dashboard__table-th--p dashboard__table-sorting text-left", _ctx.sortingClass(_ctx.orderTableColumns.Reference)]),
              "aria-sort": _ctx.sortAria
            }, [
              _createElementVNode("div", {
                class: "dashboard__table-title",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (
                                    _ctx.changeCurrentSortType(_ctx.orderTableColumns.Reference)
                                ))
              }, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.orderDetails" })
              ])
            ], 10, _hoisted_11),
            _createElementVNode("th", {
              class: _normalizeClass(["dashboard__table-th dashboard__table-sorting text-left", _ctx.sortingClass(_ctx.orderTableColumns.CarsAmount)]),
              "aria-sort": _ctx.sortAria
            }, [
              _createElementVNode("div", {
                class: "dashboard__table-title",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (
                                    _ctx.changeCurrentSortType(_ctx.orderTableColumns.CarsAmount)
                                ))
              }, [
                _createVNode(_component_i18n_t, { keypath: "cart.vehicles" })
              ])
            ], 10, _hoisted_12),
            _createElementVNode("th", {
              class: _normalizeClass(["dashboard__table-th dashboard__table-sorting text-left", _ctx.sortingClass(_ctx.orderTableColumns.Price)]),
              "aria-sort": _ctx.sortAria
            }, [
              _createElementVNode("div", {
                class: "dashboard__table-title",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeCurrentSortType(_ctx.orderTableColumns.Price)))
              }, [
                _createVNode(_component_i18n_t, { keypath: "cart.orderAmount" })
              ])
            ], 10, _hoisted_13),
            _createElementVNode("th", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.actions" })
              ])
            ])
          ])
        ]),
        _createElementVNode("tbody", _hoisted_16, [
          (!_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.orders, (_order) => {
                return (_openBlock(), _createBlock(_component_order_table_item, {
                  key: _order.id,
                  order: _order,
                  orderStatus: _ctx.currentStatus,
                  _selectedOrders: _ctx.selectedOrders,
                  "onUpdate:_selectedOrders": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOrders) = $event)),
                  _declineOrderIds: _ctx.declineOrderIds,
                  "onUpdate:_declineOrderIds": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.declineOrderIds) = $event)),
                  _approveOrders: _ctx.approveOrders,
                  "onUpdate:_approveOrders": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.approveOrders) = $event)),
                  _updateData: _ctx.updateData,
                  "onUpdate:_updateData": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.updateData) = $event)),
                  _orderPaymentDto: _ctx.orderPaymentDto,
                  "onUpdate:_orderPaymentDto": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderPaymentDto) = $event)),
                  _orderId: _ctx.orderId,
                  "onUpdate:_orderId": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderId) = $event)),
                  _isPaymentsTransactionsPopup: 
                                _ctx.isPaymentsTransactionsPopup
                            ,
                  "onUpdate:_isPaymentsTransactionsPopup": _cache[11] || (_cache[11] = ($event: any) => ((
                                _ctx.isPaymentsTransactionsPopup
                            ) = $event)),
                  _viewProformaOrder: _ctx.viewProformaOrder,
                  "onUpdate:_viewProformaOrder": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.viewProformaOrder) = $event))
                }, null, 8, ["order", "orderStatus", "_selectedOrders", "_declineOrderIds", "_approveOrders", "_updateData", "_orderPaymentDto", "_orderId", "_isPaymentsTransactionsPopup", "_viewProformaOrder"]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_p_spinner, {
                  strokeWidth: "8",
                  animationDuration: ".8s"
                })
              ]))
        ])
      ], 4)
    ])
  ]))
}